import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { CourtStructure } from './CourtStructure';

const SEL = 'w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm';
const LEVEL_GROUP = { corte_apelaciones: 'Cortes de Apelaciones', primera_instancia: 'Tribunales de primera instancia', especial: 'Tribunales especiales' };

// Region of Chile -> court of that region (+ Corte Suprema, national) with the court's current structure
export const CourtSelect = ({ region, courtSlug, onChange, testid = 'matter', showStructure = true }) => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/courts/selector').then((r) => setData(r.data)).catch(() => setData({ regions: [], national: [] })); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const reg = data?.regions.find((r) => r.name === region);
  const groups = {};
  (reg?.courts || []).forEach((c) => { const g = c.level === 'primera_instancia' ? `${LEVEL_GROUP.primera_instancia} · ${c.tipo_label || 'Otros'}` : LEVEL_GROUP[c.level] || 'Otros'; (groups[g] = groups[g] || []).push(c); });
  const all = [...(data?.national || []), ...(reg?.courts || [])];

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <select aria-label="Región" data-testid={`${testid}-region-select`} value={region || ''} className={SEL} disabled={!data}
          onChange={(e) => { const r = e.target.value; const keep = (data.national || []).find((c) => c.slug === courtSlug); onChange({ region: r, court_slug: keep ? courtSlug : '', court_name: keep?.name || '', level: keep?.level }); }}>
          <option value="">{data ? 'Región de Chile' : 'Cargando regiones...'}</option>
          {(data?.regions || []).map((r) => <option key={r.name} value={r.name}>{r.name === 'Metropolitana' ? 'Metropolitana de Santiago' : r.name}</option>)}
        </select>
        <select aria-label="Corte o tribunal" data-testid={`${testid}-court-select`} value={courtSlug || ''} className={SEL} disabled={!data}
          onChange={(e) => { const c = all.find((x) => x.slug === e.target.value); onChange({ region, court_slug: e.target.value, court_name: c?.name || '', level: c?.level }); }}>
          <option value="">{region ? 'Corte o tribunal' : 'Corte (elige región para ver más)'}</option>
          {(data?.national || []).length > 0 && (
            <optgroup label="Alcance nacional">{data.national.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}</optgroup>
          )}
          {Object.entries(groups).map(([g, list]) => (
            <optgroup key={g} label={g}>{list.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}</optgroup>
          ))}
        </select>
      </div>
      {showStructure && courtSlug && <CourtStructure slug={courtSlug} />}
    </div>
  );
};
